import admin from '@/api/admin';
import graphic from '@/api/graphic';
import client from '@/api/client';

export default {
  admin,
  client,
  graphic,
};
